import React, { useState } from 'react';
import BottomSheetModal from "../../elements/BottomSheetModal";
import Input from "../../form/Input";
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from '../../../pages/components/stripe/CheckoutForm';

const PayCustomAmount = ({ 
  isOpen, 
  onClose, 
  total, 
  selectedTip,
  stripePromise,
  paymentType,
  tableNumber,
  orderId,
  customTip = "",
  previousTransactions = [] // New prop for transaction history
}) => {
  const [payAmount, setPayAmount] = useState("");  
  const [showTransactions, setShowTransactions] = useState(false);

  // Calculate amounts
  const tipAmount = customTip ? Number(customTip) : (selectedTip || 0);
  const customPayAmount = payAmount ? Number(payAmount) : 0;
  const finalPayableAmount = customPayAmount + tipAmount;
  
  // Calculate total paid from previous transactions
  const totalPaid = previousTransactions.reduce((sum, txn) => 
    sum + (txn.amount || 0) + (txn.tip || 0), 0
  );
  
  // Calculate remaining due
  const remainingDue = total - totalPaid;

  return (
    <>
      <BottomSheetModal 
        isOpen={isOpen} 
        onClose={onClose} 
        bgclass={"p-0 pb-5 xls:max-w-sm xls:mx-auto"}
      >
        {/* Header */}
        <div className="border-b border-slate-200 mb-3">
          <div className="px-5 mt-4">
            <h2 className="text-lg font-semibold text-[#232222] mb-1">
              Pay a custom amount
            </h2>
            <p className="text-[#9FA1A3] text-base mb-4 font-normal">
              Enter any amount you wish to pay and complete your payment easily
            </p>
          </div>
        </div>

        <div className="px-5 space-y-4">
          {/* Previous Transactions Section */}
          {previousTransactions.length > 0 && (
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-4 border border-amber-200">
              {/* <button
                onClick={() => setShowTransactions(!showTransactions)}
                className="w-full flex items-center justify-between mb-2"
              >
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-clock-rotate-left text-amber-600"></i>
                  <span className="text-sm font-semibold text-gray-900">
                    Previous Transactions ({previousTransactions.length})
                  </span>
                </div>
                <i className={`fa-solid fa-chevron-${showTransactions ? 'up' : 'down'} text-amber-600 text-xs`}></i>
              </button>
              
              {showTransactions && (
                <div className="space-y-2 mt-3">
                  {previousTransactions.map((txn, index) => (
                    <div key={index} className="bg-white rounded-lg p-3 border border-amber-100">
                      <div className="flex justify-between items-start">
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <span className="text-xs font-semibold text-gray-700">
                              #{index + 1}
                            </span>
                            {txn.date && (
                              <span className="text-xs text-gray-500">
                                {new Date(txn.date).toLocaleDateString()}
                              </span>
                            )}
                          </div>
                          <div className="text-xs text-gray-600 space-y-0.5">
                            <div>Amount: ${txn.amount?.toFixed(2) || "0.00"}</div>
                            {txn.tipAmount > 0 && (
                              <div className="text-green-600">
                                Tip: +${txn.tipAmount?.toFixed(2) || "0.00"}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="text-sm font-bold text-gray-900">
                            ${((txn.amount || 0) + (txn.tipAmount || 0)).toFixed(2)}
                          </div>
                          {txn.status && (
                            <span className="text-xs text-green-600 flex items-center gap-1 justify-end mt-1">
                              <i className="fa-solid fa-check-circle"></i>
                              Paid
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                  
                  <div className="bg-amber-100 rounded-lg p-2 mt-2">
                    <div className="flex justify-between items-center">
                      <span className="text-xs font-semibold text-gray-700">
                        Total Paid
                      </span>
                      <span className="text-sm font-bold text-amber-900">
                        ${totalPaid.toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              )} */}
              
              {/* Remaining Due Summary */}
              {/* mt-3 pt-3 border-amber-200 */}
              <div className="">
                <div className="flex justify-between items-center">
                  <span className="text-sm font-semibold text-gray-700">
                    Remaining Due
                  </span>
                  <span className="text-lg font-bold text-red-600">
                    ${remainingDue.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Custom Amount Input */}
          <div className="flex items-center justify-between border border-[#D8D8D8] rounded-[10px] px-3 py-2 bg-[#F5F5F5]">
            <span className="text-[#232222] text-base font-normal flex-shrink-0">
              Pay Bill
            </span>
            <div className="w-24">
              <Input
                inputPlaceholder="$0.00"
                inputType="number"
                inputClasses="h-10 font-normal !text-base text-center border-none text-black placeholder:text-gray-400 bg-transparent"
                value={payAmount}
                onChange={(e) => setPayAmount(e.target.value)}
              />
            </div>
          </div>

          {/* Payment Breakdown - 3 Parts */}
          <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-4 space-y-2.5 border border-slate-200">
            {/* 1. Total Payable Amount (Original Bill) */}
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600 font-medium">
                Total payable amount
              </span>
              <span className="text-base font-semibold text-gray-900">
                ${total?.toFixed(2) || "0.00"}
              </span>
            </div>

            {/* Show paid amount if there are previous transactions */}
            {previousTransactions.length > 0 && (
              <>
                <div className="h-px bg-slate-300"></div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                    <i className="fa-solid fa-check-circle text-green-500 text-xs"></i>
                    Already paid
                  </span>
                  <span className="text-base font-semibold text-green-600">
                    -${totalPaid.toFixed(2)}
                  </span>
                </div>
              </>
            )}

            <div className="h-px bg-slate-300"></div>

            {/* 2. Custom Pay Amount (if provided) */}
            {customPayAmount > 0 && (
              <>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                    <i className="fa-solid fa-wallet text-blue-500 text-xs"></i>
                    Custom pay amount
                  </span>
                  <span className="text-base font-semibold text-blue-600">
                    ${customPayAmount.toFixed(2)}
                  </span>
                </div>
                <div className="h-px bg-slate-300"></div>
              </>
            )}

            {/* 3. Tip Amount (if provided) */}
            {tipAmount > 0 && (
              <>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600 font-medium flex items-center gap-1">
                    <i className="fa-solid fa-heart text-red-500 text-xs"></i>
                    Tip amount
                  </span>
                  <span className="text-base font-semibold text-green-600">
                    +${tipAmount.toFixed(2)}
                  </span>
                </div>
                <div className="h-px bg-slate-300"></div>
              </>
            )}

            {/* 4. Final Amount You're Paying */}
            <div className="flex justify-between items-center bg-white rounded-lg px-3 py-2 border border-slate-200">
              <span className="text-sm font-semibold text-gray-900">
                You are paying
                {tipAmount > 0 && <span className="text-xs text-gray-500"> (including tip)</span>}
              </span>
              <span className="text-lg font-bold text-green-600">
                ${finalPayableAmount > 0 ? finalPayableAmount.toFixed(2) : "0.00"}
              </span>
            </div>
          </div>

          {/* Info Notice */}
          {customPayAmount === 0 && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 flex items-start gap-2">
              <i className="fa-solid fa-info-circle text-blue-600 text-sm mt-0.5"></i>
              <p className="text-xs text-blue-800">
                Please enter the amount you wish to pay above
              </p>
            </div>
          )}

          {/* Payment Section */}
          <div className="rounded-xl border border-gray-200 px-3 shadow-sm pt-5 pb-3 bg-slate-50/30">
            <Elements stripe={stripePromise}>
              <CheckoutForm 
                paymentType={paymentType} 
                tableNumber={tableNumber}
                orderId={orderId}
                tipAmount={tipAmount}
                customPayAmount={customPayAmount}                
              />
            </Elements>
            
            <p className="text-[10px] text-gray-500 mt-3 text-center flex items-center justify-center gap-1">
              <i className="fa-solid fa-shield-check text-green-600"></i>
              100% Secure payments
            </p>
          </div>
        </div>
      </BottomSheetModal>
    </>
  );
};

export default PayCustomAmount;